<template>
    <MonthPickerNext
        v-bind="forwardedProps"
        :as="DsIconButton"
        icon="fa-solid fa-chevron-right"
        size="xs"
        tooltipText="Next year"
    />
</template>

<script setup lang="ts">
import DsIconButton from '@/components/design-system/button/DsIconButton.vue';
import { reactiveOmit } from '@vueuse/core';
import type { MonthPickerNextProps } from 'reka-ui';
import { MonthPickerNext, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<MonthPickerNextProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>
